import { ensureState } from 'redux-optimistic-ui';
import type { CurrentUserEntityState } from '../../reducers/entities/current-user/types.tsx';
import type { State } from '../../types.tsx';

export const getCurrentUser = (state: State): CurrentUserEntityState =>
	ensureState(state.entities).currentUser;

export const isCurrentUserLoaded = (state: State): boolean => getCurrentUser(state) !== null;
